import { useState, useEffect } from "react";
import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import CustomAccordion from "@/src/lib/ui/customAccordion";

const TestParametersList = ({ testParameters, isLoading }) => {
    const [isMounted, setIsMounted] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(null);

    const handleToggle = (itemName) => {
        setOpenAccordion(openAccordion === itemName ? null : itemName);
    };

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <section className="w-full rounded-xl border border-slate-200 bg-white p-5 md:p-7 shadow-sm">
            <h2 className="mb-4 text-lg md:text-xl font-semibold tracking-tight text-slate-900">
                Includes{" "}
                <span className="text-primary">
                    {testParameters?.inclusionCount || 0}
                </span>{" "}
                Test Parameters
            </h2>
            <div className="flex w-full flex-col gap-2.5">
                {testParameters?.inclusions?.map((item, i) => {
                    const isOpen = openAccordion === item.itemName;

                    return (
                        <CustomAccordion
                            key={item.itemName || i}
                            title={item.itemName}
                            defaultExpanded={false}
                            buttonClassName={`py-3.5 text-sm md:text-base font-semibold text-slate-900 hover:bg-slate-50! focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/30 ${
                                isOpen ? "bg-slate-50!" : "bg-white!"
                            }`}
                            className={`border border-solid rounded-lg! transition-colors ${
                                isOpen
                                    ? "border-slate-300!"
                                    : "border-slate-200! hover:border-slate-300!"
                            }`}
                            iconClassName="w-5 h-5"
                            count={item?.inclusions.length}
                            open={isOpen}
                            onClick={() => handleToggle(item.itemName)}
                        >
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 px-2 py-1">
                                {isMounted ? (
                                    item?.inclusions?.map((detail, index) => (
                                        <div
                                            className="flex items-start gap-2"
                                            key={index}
                                        >
                                            <Iconify
                                                icon={IconCode.check}
                                                width={16}
                                                className="mt-0.5 shrink-0 text-primary"
                                            />
                                            <p className="text-sm leading-5 text-slate-700">
                                                {detail.inclusionName}
                                            </p>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-sm text-slate-500">
                                        Loading...
                                    </p>
                                )}
                            </div>
                        </CustomAccordion>
                    );
                })}
            </div>
        </section>
    );
};

export default TestParametersList;
